import RouteName from '@/models/enums/RouteName'

export default [
  {
    path: '/billing/topup',
    name: RouteName.BillingTopup,
    component: () => import('../../pages/Billing/Payment.vue'),
    meta: {
      billingAction: true,
      pageTitle: 'Пополнение баланса',
    },
  },
  {
    path: '/billing/topup/result',
    name: RouteName.BillingTopupResult,
    component: () => import('../../pages/Billing/TopupResult.vue'),
    meta: {
      billingAction: true,
      pageTitle: 'Результат пополнения',
    },
  },
  {
    path: '/billing/payments/history',
    name: RouteName.BillingPaymentsHistory,
    component: () => import('../../pages/Billing/PaymentHistory.vue'),
    meta: {
      billing: true,
      pageTitle: 'История платежей',
    },
  },
  {
    path: '/billing/write-offs',
    name: RouteName.BillingWriteOffs,
    component: () => import('../../pages/Billing/WriteOffs.vue'),
    meta: {
      billing: true,
      pageTitle: 'Списания',
    },
  },
  {
    path: '/billing/my-tariff',
    name: RouteName.BillingMyTariff,
    component: () => import('../../pages/Billing/MyTariff.vue'),
    meta: {
      billing: true,
      pageTitle: 'Мой тариф',
    },
  },
  {
    path: '/billing/payment-methods',
    name: RouteName.BillingPaymentMethods,
    component: () => import('../../pages/Billing/PaymentMethods.vue'),
    meta: {
      billing: true,
      pageTitle: 'Способы оплаты',
    },
  },
]
